<template>
  <div>
    <div class="inline-block relative">
      <div>
        <div v-for="(item, index) in leaves" :key="item" class="inline-block cascader-item mr-5 last:mr-0">
          <cascader-item
            class="w-full"
            :groups="groups"
            :leave-num="item"
            :option="optionItems[index]"
            :placeholder="optionItems[index].placeholder"
            v-model="optionItems[index].value"
            :options="optionItems"
          />
        </div>
      </div>
      <div v-if="levelsNum < requiredNum" class="mt-2">
        <el-input v-for="item in issue.items" :key="item.id" v-model="item.value" placeholder="详细地址" />
      </div>
      <div v-if="view" class="absolute inset-0 z-50"></div>
    </div>
    <div class="vote-answer vote-answering-wrapper" v-if="showVoteProgress">
      <template v-if="voteItems.length">
        <div style="margin-bottom: 12px">
          投票排名
        </div>
      </template>
      <choice-vote-content :items="voteItems"/>
      <template v-if="voteItems.length > 5">
        <el-button class="w-full" @click="onShowMoreRank">查看更多排名</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import CascaderItem from '@/questions/cascader/CascaderItem'
import voteMixin from './vote'
export default {
  name: 'SelectCascader',
  mixins:[voteMixin],
  changeExpr: 'changeExpr',
  changeDelay: true,
  components: { CascaderItem },
  data() {
    return {
      levelsNum: 0,
      groups: [],
      address: '',
      fillContext: '',
      optionItems: []
    }
  },
  created() {
    
  },
  methods: {
    initIssue() {
      let issue = this.issue
      this.levelsNum = issue.levelsNum
      this.groups = issue.groups
      let optionItems = []
      let levels = issue.levels.slice()
      while (levels.length < this.requiredNum) {
        levels.push(' ')
      }
      let level

      while ((level = levels.shift())) {
        optionItems.push({
          value: '',
          placeholder: `请选择${level.trim()}`
        })
      }
      let head = null
      optionItems.forEach(item => {
        item.parent = head
        head = item
      })
      this.optionItems = optionItems
    },
    initWatchers() {
      this.$watch(
        'optionItems',
        () => {
          this.question.issue.value = this.optionItems.map(item => item.value).filter(_ => _)
        },
        { deep: true }
      )
    },
    initAnswers(){
      this.$nextTick(()=>{
        if(this.issue.value.length) {
          let value = this.issue.value.slice()
          this.optionItems.forEach(item => {
            item.value = value.shift()
          })
        }
      })
    }
  },
  watch: {
    'issue.groups':{
      handler(value){
        if (!value.length) return
        this.initIssue()
        this.initWatchers()
        this.initAnswers()
      },
      immediate: true
    }
  },
  computed: {
    changeExpr() {
      const arr = this.optionItems.slice().concat(this.issue.items.slice())
      return arr.map(i => i.value).join('-')
    },
    requiredNum() {
      return this.question.issue.requiredNum
    },
    leaves() {
      let requiredNum = this.requiredNum
      let leaves = this.levelsNum
      return Math.min(requiredNum, leaves)
    }
  },
  mounted() {
    // 旧数据默认就有groups 所以需要在这里初始化一次答案
    this.initAnswers()
  }
}
</script>
